import { FC, SVGProps } from 'react'

export const Star: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.9999 2C12.2781 2 12.5321 2.1579 12.6552 2.40731L15.3347 7.83557L21.3267 8.7114C21.6019 8.75162 21.8304 8.94454 21.9162 9.20909C22.0019 9.47363 21.9301 9.76393 21.7309 9.95797L17.3957 14.1804L18.4188 20.1457C18.4658 20.4199 18.3531 20.697 18.1281 20.8605C17.903 21.024 17.6046 21.0455 17.3584 20.916L11.9999 18.098L6.64147 20.916C6.39526 21.0455 6.09689 21.024 5.87183 20.8605C5.64677 20.697 5.53406 20.4199 5.58108 20.1457L6.60419 14.1804L2.269 9.95797C2.06978 9.76393 1.99797 9.47363 2.08374 9.20909C2.16952 8.94454 2.39802 8.75162 2.6732 8.7114L8.66522 7.83557L11.3447 2.40731C11.4678 2.1579 11.7218 2 11.9999 2ZM11.9999 4.38176L9.80593 8.82661C9.69957 9.04208 9.49409 9.19149 9.25633 9.22624L4.34888 9.94354L7.8993 13.4016C8.07167 13.5695 8.15034 13.8115 8.10967 14.0487L7.27193 18.9331L11.6598 16.6256C11.8727 16.5136 12.1272 16.5136 12.3401 16.6256L16.728 18.9331L15.8902 14.0487C15.8496 13.8115 15.9282 13.5695 16.1006 13.4016L19.651 9.94354L14.7436 9.22624C14.5058 9.19149 14.3003 9.04208 14.194 8.82661L11.9999 4.38176Z"
			fill="currentColor"
		/>
	</svg>
)
